/**
 * StatTile — compact labeled value with a colored status dot. Used for the
 * sensor-health breakdown legend.
 */

interface StatTileProps {
  label: string;
  value: number | string;
  /** Any CSS color string — pass a resolved token via chartColors.*(). */
  dotColor?: string;
  /**
   * Optional sub-line under the value — for the reference a number is meant to
   * be read against (a target, a denominator). Omitted tiles render exactly as
   * before.
   */
  hint?: string;
}

export function StatTile({ label, value, dotColor, hint }: StatTileProps) {
  return (
    <div className="flex items-center gap-2.5">
      {dotColor && (
        <span
          aria-hidden="true"
          className="h-2.5 w-2.5 shrink-0 rounded-full"
          style={{ backgroundColor: dotColor }}
        />
      )}
      <div className="min-w-0">
        <p className="truncate text-xs text-fg-muted">{label}</p>
        <p className="text-lg font-semibold tabular-nums text-fg">{value}</p>
        {hint && <p className="truncate text-xs text-fg-subtle">{hint}</p>}
      </div>
    </div>
  );
}
